import PropTypes from 'prop-types'
import {Stack} from '@mui/material'
import {
  PersonaBox,
  StyledDividerTooltip,
  StyledSpaceBox,
  StyledLabelMedium,
  StyledBody1,
  StyledTooltipData,
  StyledLabelSmallPersona,
  StyledPersonaAvatar,
  StyledPersonaHeaderStack,
  StyledPersonaTooltipPaper,
  StyledAlignCenterStack,
  StyledBracketContainer,
  StyledLabelSmall
} from './Styles'
import {dimensions, getPersonaCustomName} from '../../../helper'

const renderPersonaTooltip = (personaData, view, personasConfig) => {
  return (
    <>
      <StyledSpaceBox size={6} />
      <StyledLabelMedium>Persona stats</StyledLabelMedium>
      <StyledDividerTooltip />
      <StyledSpaceBox size={15} />
      <StyledBody1>Leading Persona</StyledBody1>
      <PersonaBox>
        <StyledAlignCenterStack direction='row' gap={1}>
          <StyledPersonaAvatar
            alt={personaData.dominant_persona}
            src={require(`../../../../../icons/Personas/${personaData.dominant_persona}.jpg`)}
          />
          <StyledPersonaHeaderStack direction='column' tabIndex={0}>
            <StyledTooltipData>{getPersonaCustomName(personaData.dominant_persona, personasConfig)}</StyledTooltipData>
            <StyledLabelSmallPersona>({personaData.persona_cohort})</StyledLabelSmallPersona>
          </StyledPersonaHeaderStack>

          <StyledPersonaTooltipPaper elevation={1}>
            <Stack direction='column'>
              <StyledBody1>Population</StyledBody1>
              {view === 'state' ? (
                <StyledAlignCenterStack direction='row' spacing={1} justifyContent={'space-between'}>
                  <StyledTooltipData>{personaData.persona_population}</StyledTooltipData>
                  <StyledLabelSmall> ({personaData.statePercentage}% of State)</StyledLabelSmall>
                </StyledAlignCenterStack>
              ) : (
                <Stack direction='row' spacing={1} justifyContent={'space-between'}>
                  <StyledTooltipData>{personaData.persona_population}</StyledTooltipData>
                  <StyledBracketContainer direction='column'>
                    <StyledLabelSmall>
                      {' '}
                      {personaData[`${view}Percentage`]}% of {dimensions[view]}
                    </StyledLabelSmall>
                    {view !== 'censusTract' && (
                      <StyledLabelSmall> {personaData.statePercentage}% of State</StyledLabelSmall>
                    )}
                    {view === 'censusTract' && (
                      <StyledLabelSmall> {personaData.countyPercentage}% of County</StyledLabelSmall>
                    )}
                  </StyledBracketContainer>
                </Stack>
              )}
            </Stack>
          </StyledPersonaTooltipPaper>
        </StyledAlignCenterStack>
      </PersonaBox>
    </>
  )
}

renderPersonaTooltip.propTypes = {
  personaData: PropTypes.shape({
    dominant_persona: PropTypes.string,
    persona_population: PropTypes.number,
    persona_cohort: PropTypes.string
  }).isRequired
}

export {renderPersonaTooltip}

/**
 * List of functions and their purpose:
 *
 * - renderRowData: Formats numeric or string data for display in the tooltip.
 * - renderPersonaTooltip: Renders a tooltip displaying persona details, including leading persona, population, and cohort.
 */
